import { ActionFunction, ActionFunctionArgs } from "react-router-dom";
import ENDPOINTS from "../../services/endpoints";

export default (async (props: ActionFunctionArgs) => {
  const body = await props.request.formData();
  const email = body.get("email") as string;
  const password = body.get("password") as string;

  const requestBody = JSON.stringify({ Username: email, Password: password });

  return new Promise((res) => {
    fetch(ENDPOINTS.LOGIN, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        // "Access-Control-Allow-Origin": "*",
      },
      body: requestBody,
    })
      .then(async (fetchResponse) => {
        if (fetchResponse.ok) {
          const response = await fetchResponse.json();
          res(response);
        } else {
          const errorMessage = await fetchResponse.text();
          res(
            new Response(
              JSON.stringify({
                message: errorMessage || "Invalid credentials",
              }),
              {
                status: 400,
                headers: { "Content-Type": "application/json" },
              }
            )
          );
        }
      })
      .catch((err) => {
        console.error(err);
        res(
          new Response(
            JSON.stringify({ message: "Invalid credentials", err }),
            {
              status: 400,
              headers: { "Content-Type": "application/json" },
            }
          )
        );
      });
  });
}) as ActionFunction;
